import React, {useState, useEffect} from "react"
import MyButton from './UI/button/MyButton'
import MyInput from './UI/input/MyInput'

const ModelForm = ({create}) => {

  const [model, setModel] = useState({title: '', body: ''})
  const [isCorrectInput, setCorrectInput] = useState(true)

  const addNewModel = (e) => {
    e.preventDefault()
    console.log('model: ',model)
    if(model.title && model.body) {
      const newModel = {
          ...model, id: Date.now()
      }
      create(newModel)
      setModel({title: '', body: ''})
    } else{
      console.log('Error: you need input correct values.')
      setCorrectInput(false)
    }
  }

  useEffect(() => {
    setCorrectInput(true)
  }, [model]);

    return (
        <div>
            <form>
              {/* Управляемый компонент */}
              <MyInput 
                value={model.title}
                onChange={e => setModel({...model, title: e.target.value})}
                type="text" 
                placeholder='Name of model'
              />
              <MyInput 
                value={model.body}
                onChange={e => setModel({...model, body: e.target.value})}
                type="text" 
                placeholder='Description of model'
              />
              <MyButton onClick={addNewModel}>
                Add model
              </MyButton>
            </form>
            {isCorrectInput
              ? 
                <p>...</p>
              : 
                <h2 style={{textAlign: 'center', color: 'red'}}>
                  Error: you need input correct values. 
                </h2>
            }
        </div>
    )
}

export default ModelForm

